import { IBindable, TagManualInputValues } from '../../models';
import { WidgetBase } from '../models';
import { IWidgetControl, IControlWidget, ICancellableWidget } from '../interfaces';
import { ManualInputsWidgetConfiguration } from './manualInputs.configuration';
import { Helper } from '../../common';
import { ManualInputsWidgetDefinition as definition } from './manualInputs.definition';

export class ManualInputsWidget extends WidgetBase implements IControlWidget, ICancellableWidget {
    _pristine: any;
    baseType = definition.baseType;
    col = 0;
    configuration = new ManualInputsWidgetConfiguration();
    ctrl: IWidgetControl;
    group = definition.group;
    guid: string;
    hasExtendedProperties = false;
    highlights = definition.highlights;
    icon = '';
    inputList?: TagManualInputValues[];
    isTitleHidden = false;
    name = definition.title;
    row = 0;
    sizeX = 4;
    sizeY = 12;
    type = definition.type;

    constructor() {
        super();
        this.guid = Helper.getGuid();
        if (!this.configuration.taskOptionsOverride) {
            this.configuration.taskOptionsOverride = { includeDependent: true };
        }
    }

    getSeries(): IBindable[] {
        const self = this;
        return [{
            set guid(value) {
                self.configuration.group = value;
            },
            get guid() {
                return self.configuration.group;
            },
            //guid: this.configuration.group,
            originalGuid: this.configuration.group,
            isBoundToGroup: this.configuration.isBound,
            value: ''
        }];
    }

    getSeriesGuids(): string[] {
        return this.inputList?.map(d => d.identifierVm?.guid ?? d.guid) ?? [];
    }
}